import { faFile } from '@fortawesome/pro-regular-svg-icons';

import { PATH } from '@constants';
import { contextNamesSelector } from '@selectors';
import { useSelector } from '@hooks';
import { path } from '@utils/path';

import { Icon, Link } from '@components/Shared';

const STORAGE_PREFIX = 'storage:';

type Props = {
  value: string;
};

export const ParamReferenceStorage: React.FC<Props> = ({ value }) => {
  const { organizationName, projectName } = useSelector(contextNamesSelector);

  const storagePath: string = (() => {
    if (value.startsWith(`${STORAGE_PREFIX}//`)) {
      return path.storage(
        path.create(
          value.slice(`${STORAGE_PREFIX}//`.length),
          organizationName,
          projectName,
        ),
      );
    }

    if (value.startsWith(`${STORAGE_PREFIX}/`)) {
      return path.storage(
        value.replace(`${STORAGE_PREFIX}/`, `/${organizationName}/`),
      );
    }

    if (value.startsWith(STORAGE_PREFIX)) {
      return path.storage(
        value.replace(STORAGE_PREFIX, `/${organizationName}/${projectName}/`),
      );
    }

    return PATH.STORAGE;
  })();

  return (
    <Link
      theme
      to={storagePath}
      className="flex items-center gap-1.5 text-primary"
    >
      {value} <Icon icon={faFile} className="text-[18px]" />
    </Link>
  );
};
